// DEV-ONLY · Device Presentation Pass 01 — Vorschau B1 GBU + B4 Wiedervorlage
// im neuen iMac-/Monitor-Look. Zeigt die ECHTEN bestehenden Screenshots im
// Device (kein Fake-UI, kein neu generierter Screenshot). Kein Einfluss auf /abo.
// Zweck: EINE gemeinsame Device-Sprache beurteilen (Desktop 1920 + Mobile 390),
// bevor sie auf weitere Bühnen übertragen wird. STOP-GATE nach der Vorschau.
import { useEffect, useRef } from "react";
import AboChris from "@/components/abo/AboChris";
import { AboImacMockup } from "@/components/abo/AboMockups";
import { Badge } from "@/components/abo/AboStory";
import "@/pages/abo/abo.css";

const SHOT = (name) => `/abo/screenshots/${name}`;
const OUTFIT =
  "https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap";

export default function AboDeviceDevPreview() {
  const ref = useRef(null);
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = OUTFIT;
    document.head.appendChild(link);
    ref.current?.querySelectorAll(".reveal").forEach((el) => el.classList.add("in"));
    return () => link.remove();
  }, []);

  return (
    <div
      className="abo-root"
      lang="de"
      ref={ref}
      data-testid="abo-device-dev"
      style={{ minHeight: "100vh" }}
    >
      <style>{`
        [data-testid="abo-device-dev"] .reveal{opacity:1 !important;transform:none !important;}
        [data-testid="abo-device-dev"] .dev-label{max-width:1280px;margin:0 auto;padding:22px 24px 0;font:600 0.72rem/1.4 "Outfit",sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#94a3b8;}
        [data-testid="abo-device-dev"] .abo-b4-imac-desktop{display:none;}
        [data-testid="abo-device-dev"] .abo-b4-imac-mobile{display:flex;flex-direction:column;gap:14px;}
        @media(min-width:1000px){
          [data-testid="abo-device-dev"] .abo-b4-imac-desktop{display:block;}
          [data-testid="abo-device-dev"] .abo-b4-imac-mobile{display:none;}
        }
      `}</style>

      {/* ---------- B1 · GBU im iMac-Look ---------- */}
      <div className="dev-label">Device Pass 01 · B1 Gefährdungsbeurteilung</div>
      <section className="abo-stage abo-stage--light" data-testid="dev-stage-gbu">
        <div className="abo-stage-wrap">
          <div className="abo-stage-grid">
            <div className="abo-stage-copy reveal">
              <div className="abo-stage-meta">
                <span className="abo-stage-kicker">Was Chris für Sie übernimmt</span>
                <Badge kind="grund" />
              </div>
              <h2 className="abo-stage-title">Ein Wort statt leerem Formular.</h2>
              <p className="abo-stage-line">Tippen. Vorschlag prüfen. Freigeben.</p>
              <AboChris
                pose={13}
                size="md"
                testId="dev-chris-gbu"
                text="Sagen Sie mir, worum es geht. Ich bereite alles vor – Sie prüfen nur noch."
              />
            </div>
            <div className="abo-stage-media reveal">
              <AboImacMockup
                src={SHOT("crops/gbu-search.webp")}
                alt="CLartext Gefährdungsbeurteilung: ein Stichwort ins Suchfeld – die passende Vorlage wird vorgeschlagen"
                testId="dev-imac-gbu"
                eager
              />
              <p className="abo-stage-cap">
                Ein Stichwort genügt – CLartext schlägt die passende Grundlage vor.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- B4 · Wiedervorlage/Ampel im iMac-Look ---------- */}
      <div className="dev-label">Device Pass 01 · B4 Wiedervorlage / Ampel</div>
      <section className="abo-stage abo-stage--wv" data-testid="dev-stage-wv">
        <div className="abo-stage-wrap">
          <header className="abo-wv-head reveal">
            <span className="abo-stage-kicker">Wiederholungen laufen weiter</span>
            <h2 className="abo-stage-title">
              Einmal eingerichtet. Beim nächsten Mal kümmert sich Chris wieder darum.
            </h2>
          </header>
          <div className="abo-wv-stage reveal">
            <div className="abo-wv-proof">
              <div className="abo-b4-imac-desktop">
                <AboImacMockup
                  src={SHOT("wiedervorlage-ampel.webp")}
                  alt="CLartext Unterweisungsübersicht: Handlungsbedarf 17, Bald fällig 0, Erledigt 268 – und fällige Aufgaben mit Datum."
                  testId="dev-imac-wv"
                  eager
                />
              </div>
              <div className="abo-b4-imac-mobile">
                <AboImacMockup
                  compact
                  src={SHOT("wiedervorlage-ampel-cards.webp")}
                  alt="CLartext Ampel: Handlungsbedarf 17, Bald fällig 0, Erledigt 268."
                  testId="dev-imac-wv-cards"
                  eager
                />
                <AboImacMockup
                  compact
                  src={SHOT("wiedervorlage-ampel-rows.webp")}
                  alt="CLartext: fällige Aufgabe mit Mitarbeiterzahl und Datum."
                  testId="dev-imac-wv-rows"
                  eager
                />
              </div>
            </div>
            <div className="abo-wv-side">
              <AboChris
                pose={17}
                size="lg"
                testId="dev-chris-wv"
                text="Ich lege die nächste Wiederholung an, bringe sie wieder zu Ihrem Mitarbeiter und behalte den Stand für Sie im Blick."
              />
            </div>
          </div>
          <div className="abo-wv-foot reveal">
            <p className="abo-wv-benefit">Keine Kalenderlisten. Kein erneutes Anlegen.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
